import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_card",
  "use": "icon-project_card-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_card\"><g transform=\"translate(0 3)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\"><rect x=\"1\" y=\"1\" width=\"26\" height=\"20\" rx=\"4\" /><path stroke-linecap=\"round\" d=\"M5 10h6\" /><circle cx=\"20\" cy=\"8\" r=\"3\" /><path stroke-linecap=\"round\" d=\"M5 16h12\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol